import pressListSection from './press/pressListSection';

export default function pressList() {
    const sections = document.querySelectorAll('[data-press-list]');

    if (sections) {
        sections.forEach(section => new pressListSection(section));
    }
}
